<template>
  <div class="centix-dateinput">
    <span class="holder-span">
      <div
            @dblclick="doubleClicked()"
            class="FormDate"
            :class="{ filled : validDate, disabled: !isEnabled, required: showRequiredClass }"
            v-on:keyup.esc="$event.target.blur()">

            <input
              v-if="showDay"
              ref="day"
              v-model="day"
              class="FormDate__input FormDate__input--day form-control input-item"
              type="number"
              placeholder="dd"
              @input="updateDay"
              @click="selectText"
              @blur="onDayBlur"
              @keyup.enter="onReturn"
              :disabled="!isEnabled">

            <span
            v-if="showDay && showMonth"
            class="FormDate__divider"
            >/</span>

    <input
              v-if="showMonth"
              ref="month"
              v-model="month"
              class="FormDate__input FormDate__input--month form-control input-item"
              type="number"
              placeholder="mm"
              @input="updateMonth"
              @click="selectText"
              @blur="onMonthBlur"
              @keyup.enter="onReturn"
              :disabled="!isEnabled">

    <span
            v-if="showYear && (showDay || showMonth)"
            class="FormDate__divider"
            >/</span>

    <input
              v-if="showYear"
              ref="year"
              v-model="year"
              class="FormDate__input FormDate__input--year form-control input-item"
              type="number"
              @click="selectText"
              placeholder="yyyy"
              @blur="onYearBlur"
              @input="updateYear"
              @keyup.enter="onReturn"
              :disabled="!isEnabled">

    <input
              v-if="showHours && showTime"
              ref="hours"
              v-model="hours"
              class="FormDate__input FormDate__input--year form-control input-item"
              type="number"
              @click="selectText"
              placeholder="HH"
              @blur="onHoursBlur"
              @input="updateHours"
              @keyup.enter="onReturn"
              :disabled="!isEnabled">

    <span
            v-if="showHours && showTime"
            class="FormDate__divider"
            >:</span>

    <input
              v-if="showMinutes && showTime"
              ref="minutes"
              v-model="minutes"
              class="FormDate__input FormDate__input--year form-control input-item"
              type="number"
              @click="selectText"
              placeholder="mm"
              @blur="onMinutesBlur"
              @input="updateMinutes"
              @keyup.enter="onReturn"
              :disabled="!isEnabled">
        </div>
    </span>
  </div>
</template>

<script>
import moment from 'moment/src/moment';

export default {
  name: 'DateTimeInput',
  props: {
    showDay: {
      type: Boolean,
      default: true
    },
    showMonth: {
      type: Boolean,
      default: true
    },
    showYear: {
      type: Boolean,
      default: true
    },
    showHours: {
      type: Boolean,
      default: true
    },
    showMinutes: {
      type: Boolean,
      default: true
    },
    showTime: {
      type: Boolean,
      default: true
    },
    value: {
      default: null
    },
    isEnabled: {
      type: Boolean,
      default: true
    },
    doubleClickDateNow: {
      type: Boolean,
      default: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'value',
    event: 'value-changed'
  },
  data() {
    return {
      hasFocus: false,
      hasError: false,
      lastError: '',
      day: '',
      month: '',
      year: '',
      hours: '',
      minutes: '',
      allValid: true
    };
  },
  methods: {
    /**
     * prefills the year with current year if showyear and year is empty
     */
    prefillYear() {
      if (this.showYear && !this.year) {
        this.year = moment().year().toString();
      }
    },
    doubleClicked() {
      if (this.isEnabled && this.doubleClickDateNow) this.$emit('value-changed', moment().toDate());
    },
    onDayBlur() {
      let day = parseInt(this.day, 10);
      if (day > 31) this.day = 31;
      this.day = this.day.toString().padStart(2, 0);
      this.prefillYear();
      this.checkAndRaiseValue();
    },
    onMonthBlur() {
      let m = parseInt(this.month);
      if (m > 12) this.month = 12;
      this.month = this.month.toString().padStart(2, 0);
      this.prefillYear();
      this.checkAndRaiseValue();
    },
    onYearBlur() {
      if (this.year.length === 2) {
        this.year = `20${this.year}`;
      }
      this.checkAndRaiseValue();
    },
    onHoursBlur() {
      this.checkAndRaiseValue();
    },
    onMinutesBlur() {
      this.checkAndRaiseValue();
    },
    selectText(event) {
      event.target.select();
    },
    checkAndRaiseValue() {
      let valid = true;
      if (this.showYear && this.year.length === 0) valid = false;
      if (this.showMonth && this.month.length === 0) valid = false;
      if (this.showDay && this.day.length === 0) valid = false;
      this.allValid = valid;
      let newdate = this.getDateFromValues();
      this.$log('check raise value', valid, newdate, newdate.isValid());
      if (this.allValid && !equalDates(this.value, newdate, this.showHours, this.showMinutes)) {
        this.$emit('value-changed', newdate.toDate());
      }
    },
    getDateFromValues() {
      let now = moment();
      let newdate = moment({
        years: this.showYear ? this.year : now.year(),
        months: this.showMonth ? (parseInt(this.month) - 1) : now.month(),
        date: this.showDay ? this.day : now.date(),
        hours: this.showHours ? this.hours : now.hours(),
        minutes: this.showMinutes ? this.minutes : now.minutes()
      });
      return newdate;
    },
    clearForm() {
      this.$emit('value-changed', null);
    },
    updateDay() {
      if (!this.day.length || ((parseInt(this.day, 10) < 4) && this.day.length === 1)) return;
      if (this.showMonth) this.$refs.month.select();
      else if (this.showYear) this.$refs.year.select();
    },
    updateMonth() {
      if (!this.month.length) return;
      let month = parseInt(this.month, 10);
      if (month === 0 || (month === 1 && this.month.length === 1)) return;
      if (this.showYear) this.$refs.year.select();
    },
    updateYear() {
      if (this.year.length < 4) return;
      if (this.showHours) this.$refs.hours.select();
    },
    updateHours() {
      if (this.hours.length === 0) return;
      let hours = parseInt(this.hours, 10);
      if (hours >= 24) this.hours = 0;
      if (hours > 2) this.$refs.minutes.select();
      if (this.hours.length === 2) this.$refs.minutes.select();
    },
    updateMinutes() {
      if (this.minutes.length === 0) return;
      let minutes = parseInt(this.minutes, 10);
      if (minutes > 59) this.minutes = '00';
      if (this.minutes.length === 3) {
        this.minutes = this.minutes.substr(0, 2);
        this.$refs.minutes.blur();
      }
    },
    onReturn() {
      this.$emit('on-return');
    }
  },
  computed: {
    showRequiredClass: function () {
      if (this.required && !this.hasValue) {
        return true;
      } else {
        return false;
      }
    },
    validDate: function () {
      if (!this.value) return false;
      let newdate = this.getDateFromValues();
      return newdate.isValid();
    },
    hasValue () {
      return this.value && this.value !== null && this.value !== undefined;
    }
  },
  watch: {
    year(current, prev) {
      if (current > 9999) this.year = prev;
    },
    value() {
      let m = moment(this.value);
      if (m.isValid()) {
        this.day = m.date().toString().padStart(2, 0);
        this.month = (m.month() + 1).toString().padStart(2, 0);
        this.year = m.year().toString();
        this.hours = m.hours().toString().padStart(2, 0);
        this.minutes = m.minutes().toString().padStart(2, 0);
      }
      else {
        this.day = this.month = this.year = this.hours = this.minutes = '';
      }
    }
  },
};

const equalDates = (date, date2, showHours, showMinutes) => {
  
  date = moment(date);
  date2 = moment(date2);

  let resetValue = {hours: !showHours ? 0 : undefined, minutes: !showMinutes ? 0: undefined, second: 0, millisecond: 0};
  date.set(resetValue);
  date2.set(resetValue);

  console.log(date, date2, date.valueOf(), date2.valueOf());
  if (date.isValid() && date2.isValid() && date.valueOf() === date2.valueOf()) {
    return true;
  }
};

</script>

<style lang="scss" scoped>
@import 'styles/settings.scss';

.centix-dateinput {
  display: inline-block;
  // width: 100%;

  &:not(.disabled) {
    .input-item {
      &.required {
        border: 1px solid $error;
      }

      &.filled {
        padding-right: 25px;
        border: 1px solid #80bdff;
      }
    }
  }

  &.disabled {
    input {
      pointer-events: none;
      background: $input-disabled-bg;
    }
  }

  &:hover {
    .clear-button {
      display: block;
    }
  }
  span.holder-span {
    position: relative;
    display: block;
    width: 100%;
  }

  .clear-button {
    position: absolute;
    right: 0;
    top: 0;
    background: url('../../assets/remove.png') transparent no-repeat center right 16px;
    background-size: 12px 12px;
    width: 50px;
    height: 100%;
    cursor: pointer;
    display: none;
  }

  .loading-spinner,
  .error-popper {
    position: absolute;
    right: 4px;
    top: 4px;
    background: #fff;
  }

  .model-state-error {
    color: $error;
  }
}

.FormDate {
  $spacing: 7px;
  display: inline-flex;
  position: relative;
  border: 1px solid #d1d0cf;
  border-radius: 4px;
  &.disabled {
    background: $input-disabled-bg;
  }
  &.required {
    border: 1px solid $error;
  }
  // 1. Hide the spinner button in Chrome, Safari and Firefox.
  &__input {
    padding: $spacing;
    padding-right: $spacing / 2;
    padding-left: $spacing / 2;
    border: none;
    text-align: center;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -moz-appearance: textfield; // 1

    &::-webkit-inner-spin-button {
      display: none; // 1
    }

    &:first-child {
      padding-left: $spacing;
    }

    &:last-child {
      padding-right: $spacing;
    }

    &:focus {
      outline: none;
      box-shadow: none;
    }

    &::placeholder {
      color: #c3c8cc;
    }
    max-width: 3em;

    &--day,
    &--month {
      width: 3em;
    }

    &--year {
      width: 4em;
      max-width: 4em;
    }
  }

  &__divider {
    padding-top: $spacing;
    padding-bottom: $spacing;
    pointer-events: none;
  }

  &.filled {
    // border: 1px solid #80bdff;
  }
}
</style>
